import type { SearchApiDocument } from '../../../../api/model/response/documents/SearchResult';
import type {B2cResources, PrsmProduct} from '../../../../api/model/response/documents/public/PrsmDocument';
import type { LabelListElement } from '../../result-cards/subcomponents/uiaas-search-label-list';

export function defaultLabelsList(
  doc: SearchApiDocument,
  accessibilityMode = false
): LabelListElement[] {
    const {category, date, eanCode, enumber, idHighlighted, id} = doc as SearchApiDocument;

    return [
      {label: enumber?.label, value: enumber?.value, customValueClass: 'result-card__enumber'},
      {value: idHighlighted || id, customValueClass: 'result-card__sku'},
      {label: eanCode?.label, value: eanCode?.value, customValueClass: 'result-card__product-number'},
      {value: category?.CT_CAT, customValueClass: `result-card__category${accessibilityMode ? '-accessibility' : ''}`},
      {value: date},
    ];
}

export function defaultFileDescription(version, language, languageList:Array<any>): LabelListElement[] {//eslint-disable-line @typescript-eslint/no-explicit-any

    const locale = new Intl.DisplayNames([language], { type: 'language' });
    const localesList = languageList
      .filter(element => element !== '**')
      .filter(Boolean)
      .map(element => locale.of(element.slice(0, 2)));

    return [
      {label: 'tab.label.language', fallbackLabel: 'Language', value: localesList.length > 0 ? localesList.join(', ') : locale?.of(language)},
      {label: 'tab.label.latest-version', fallbackLabel: 'Latest version', value: version},
    ];
}

export function prsmLabelsList(doc: PrsmProduct, accessibilityMode = false): LabelListElement[] {
    const {commercialReference} = {
      ...doc as PrsmProduct,
    };
    return [
      {value: commercialReference},
    ];
}

export function b2cLabelsList(doc: PrsmProduct): LabelListElement[] {
    const {id} = {
      ...doc as PrsmProduct,
    };
    return [
      {value: id, customValueClass: 'result-card__sku'},
    ];
}

export function b2cResourcesLabelsList(doc: PrsmProduct, language, languageList:Array<any>): LabelListElement[] {//eslint-disable-line @typescript-eslint/no-explicit-any
    const {f3Cat, date, attachments, onlinePreviewUrl} = {
      ...doc as unknown as B2cResources,
    };

    const locale = new Intl.DisplayNames([language], { type: 'language' });
    const localesList = languageList
      .filter(element => element !== '**')
      .filter(Boolean)
      .map(element => locale.of(element.slice(0, 2)));

    return [
      {value: f3Cat, customValueClass: 'result-card__sku'},
      !onlinePreviewUrl && {label: 'tab.label.file-size', fallbackLabel: 'File size', value: attachments[0]?.length, customValueClass: 'result-card__enumber'},
      {value: date, customValueClass: 'result-card__sku'},
      {label: 'tab.label.language', fallbackLabel: 'Language', value: localesList.length > 0 ? localesList.join(', ') : locale?.of(language)},
    ];
}